module.exports = __webpack_public_path__ + "static/media/logo-tans.d5b07524.png";